import {calculatePagesAmount} from '#utils/common.ts';
import {formatDateToDayMonthYearFormat} from '#utils/date.ts';

export const getNotificationsResponseTransformer = ({data, pagination}) => ({
  notifications: data.map(notification => ({
    id: notification.id,
    isRead: notification.is_read,
    isActionRequired: notification.is_action_required,
    title: notification.title,
    text: notification.subtext?.length
      ? `${notification.text} ${notification.subtext}`
      : notification.text,
    date: formatDateToDayMonthYearFormat(notification.created_at),
    type: notification.type
  })),
  pagination: {
    totalItemsAmount: pagination.total,
    totalPagesAmount: calculatePagesAmount({
      totalItems: pagination.total,
      itemsPerPage: pagination.limit
    }),
    currentPage: pagination.current_page,
    limit: pagination.limit,
    hasMore: pagination.has_more
  }
});

export const getNotificationByIdResponseTransformer = ({
  data: notification
}) => ({
  notification: {
    id: notification.id,
    title: notification.title,
    text: notification.text,
    subtext: notification?.subtext,
    date: formatDateToDayMonthYearFormat(notification.created_at),
    type: notification.type,
    imageUrl: notification.image_url,
    invitationStatus: notification.event_data?.request_status,
    adminMessage: notification.admin_message,
    eventId: notification.event_id,
    orgAdded: notification.organisations_added,
    orgRemoved: notification.organisations_removed,
    benefitId: notification.benefit_id,
    eventData: notification.event_data
  }
});
